import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-alerts',
  templateUrl: './ui-alerts.component.html',
  styleUrls: ['./ui-alerts.component.scss']
})
export class UiAlertsComponent implements OnInit {
  viewTab1: boolean = true;
  codeTab1: boolean;
  viewTab: boolean = true;
  codeTab: boolean;
  viewTab2: boolean = true;
  codeTab2: boolean;
  bootTab: boolean;
  viewTab3: boolean = true;;
  codeTab3: boolean;

  constructor() { }

  ngOnInit(): void {
  }

  onMenuTab(number) {
    this.viewTab = false;
    this.codeTab = false;
    this.bootTab = false;

    if (number == '1') {
      this.viewTab = true;
    }
    else if (number == '2') {
      this.bootTab = true;
    }
    else if (number == '3') {
      this.codeTab = true;
    }
  }

  onMenuTab1(number) {
    this.viewTab1 = false;
    this.codeTab1 = false;

    if (number == '1') {
      this.viewTab1 = true;
    }
    else if (number == '2') {
      this.codeTab1 = true;
    }
  }

  onMenuTab2(number) {
    this.viewTab2 = false;
    this.codeTab2 = false;

    if (number == '1') {
      this.viewTab2 = true;
    }
    else if (number == '2') {
      this.codeTab2 = true;
    }
  }

  onMenuTab3(number) {
    this.viewTab3 = false;
    this.codeTab3 = false;

    if (number == '1') {
      this.viewTab3 = true;
    }
    else if (number == '2') {
      this.codeTab3 = true;
    }
  }

}
